// Shape persisted at localStorage[USER_ANALYTICS_STORAGE_KEY].
// Semantics + the pre-existing-user +1 offset: docs/user-analytics.md
export interface UserAnalyticsData {
  /** ISO timestamp */
  firstSeen: string;

  preExistingUser: boolean;

  /** Keyed by first URL segment: { ring: 5, shop: 1, homepage: 3 } */
  sectionVisits: Record<string, number>;

  /** Keyed by first two URL segments: { 'ring/buy': 3 } */
  subsectionVisits: Record<string, number>;

  totalVisits: number;

  /** ISO timestamp */
  lastVisit: string;

  /** Pathname */
  lastPage: string;
}

export const DEFAULT_USER_ANALYTICS: UserAnalyticsData = {
  firstSeen: '',
  preExistingUser: false,
  sectionVisits: {},
  subsectionVisits: {},
  totalVisits: 0,
  lastVisit: '',
  lastPage: '',
};

export interface UserAnalyticsContextValue {
  data: UserAnalyticsData;
  isPreExistingUser: boolean;
  firstSeen: string;
  totalVisits: number;
  getSectionVisits: (section: string) => number;
  getSubsectionVisits: (subsection: string) => number;
  ringVisits: number;
  ringBuyVisits: number;
  homeVisits: number;
  homeBuyVisits: number;
}
